import React from 'react'
import { Box, BoxProps } from 'uikit'

const Container: React.FC<BoxProps> = ({ children, ...props }) => (
  <Box px={['0', '0', '0', '0', '24px']} mx="auto" maxWidth="1260px" {...props}>
    {children}
  </Box>
)

export default Container
